import $ from "jquery";
import Splide from '@splidejs/splide';

class Slider {
	constructor() {
		this.init();
		this.initHeroSliders();
	}

	init() {
		this.dom();
	}

	dom() {
		this.$body = $('body');
		this.$sliders = $('.splide');
		this.$heroSliders = this.$sliders.filter('.slider-hero');
	}

	initHeroSliders() {
		this.$heroSliders.each((i) => {
			const $slider = this.$heroSliders.eq(i);

			if (!$slider.data('splide')) {
				const splide = new Splide($slider[0], {
					type: 'loop',
					speed: 1000,
					autoplay: true,
					interval: 8000,
					pauseOnHover: false,
					pauseOnFocus: false
				}).mount();

				function updateSplideOnResize() {
					const windowWidth = $(window).width();
					const $slide = $slider.find('.splide__slide');
					const $sliderPagination = $slider.find('.splide__pagination');
					const $sliderArrow = $slider.find('.splide__arrow');

					const quoteSliderHeight = $slider.find('.quote-slider').outerHeight();

					if (windowWidth < 768) {
						$slide.css({'padding-bottom': (quoteSliderHeight + $sliderPagination.outerHeight()) + 'px'})
						$sliderPagination.css({'bottom': quoteSliderHeight + 'px'});
						$sliderArrow.css({'bottom': quoteSliderHeight + 'px'});
					} else {
						$slide.css({'padding-bottom': ''})
						$sliderPagination.css({'bottom': ''});
						$sliderArrow.css({'bottom':  ''});
					}
				}
				splide.on('resize', updateSplideOnResize);

				$slider.data('splide', splide);
			}
		});
	}
}

export default Slider;
